import React, { useState, useEffect, useContext } from "react";
import "popper.js";
import "bootstrap/dist/js/bootstrap";
import { useHistory } from "react-router-dom";
// Componentes
import Foto from "../element/Foto";
import HeaderMenu from "../element/HeaderMenu";
import Menu from "./Menu";
import SkeletonCard from "../element/Skeleton";
import EmptyState from "../element/EmptyState";
// Contexto
import dataContext from "../context/User";
// Helper
import GetFetchContentfulCMS from "../helper/GetFetchContentfulCMS";
import SetBitacora from "../helper/SetBitacora";
import loadMenu from "../js/main";
import Footer from "./Footer";

const PasantiasTips = () => {
  const history = useHistory();
  const dataUser = useContext(dataContext);
  let datos = localStorage.getItem("dataUser");

  const [tips, setTips] = useState();
  const [cargando, setCargando] = useState(true);
  useEffect(() => {
    if (datos) {
      let cred = JSON.parse(datos);
      dataUser.token = cred.token;
      dataUser.nombre = cred.nombre;
      dataUser.carnet = cred.carnet;

      let getContenido = async () => {
        let contenido = GetFetchContentfulCMS.allContenidoPasantiasTips();
        await contenido.then((datosC) => {
          setTips(datosC.items);
          setCargando(false);
        }).catch(() => setCargando(false));
      };

      SetBitacora.set(cred.carnet, 'Pasantias_PF', cred.token);
      getContenido();

      loadMenu();
    } else {
      history.push("/");
    }
  }, [datos, history, dataUser]);
  return (
    <div className="wrapper d-flex align-items-stretch">
      <nav id="sidebar">
        <div className="custom-menu">
          <button
            type="button"
            id="sidebarCollapse"
            className="btn btn-primary"
          >
            <i className="fa fa-bars"></i>
            <span className="sr-only">Toggle Menu</span>
          </button>
        </div>
        <div className="p-4">
          <Foto foto={dataUser.carnet} alt="Foto alumno" tamanio="rounded" />

          <HeaderMenu
            carnet={dataUser.carnet}
            nombre={dataUser.nombre}
            posicion="text-center"
          />

          <Menu />

          <Footer />
        </div>
      </nav>

      <div id="content" className="p-4 p-md-5 pt-5">
        <h2 className="mb-4">Tips para pasantías</h2>
        <div id="content" className="row">
          {cargando ? (
            <div className="col-12">
              <SkeletonCard rows={5} />
            </div>
          ) : tips && tips.length > 0 ? (
            tips.map((el, key) => {
              return (
                <div key={key} className="col-12">
                  <div className="card mb-3">
                    <div className="card-body">
                      <h5 className="card-title">
                        <i className="fa fa-lightbulb-o text-primary mr-2" aria-hidden="true"></i>
                        {el.fields.pregunta}
                      </h5>
                      <p className="card-text mb-0">{el.fields.respuesta.content[0].content[0].value}</p>
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="col-12">
              <EmptyState icon="fa-lightbulb-o" title="Aún no hay tips publicados">
                Cuando se publiquen consejos para tu pasantía, aparecerán aquí.
              </EmptyState>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PasantiasTips;
